<ion-content [fullscreen]="true" class="ion-padding">

  <div class="login-container">
    <div class="login-box">
      <div class="login-image">
        <img src="../../../assets/totalum-logo-blue-text.png" alt="Totalum logo">
      </div>

      <div class="login-title">
        {{ 'LOGIN_OR_REGISTER' | translate }}
      </div>

      <form [formGroup]="loginForm">
        <ion-list>

        <b> {{ 'INSERT_EMAIL' | translate }}</b>

        <ion-item lines="full" class="form-inputs-margin">
          <ion-input 
          type="email"
          placeholder="{{ 'INSERT_EMAIL' | translate }}"
          [clearInput]="true"
          label="EMAIL" label-placement="stacked"
          formControlName="email"
          ></ion-input>
        </ion-item>
        <div class="form-input-error" color="danger" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
          <ng-container *ngIf="loginForm.get('email')?.hasError('required')">{{ 'EMAIL_REQUIRED' | translate }}</ng-container>
          <ng-container *ngIf="loginForm.get('email')?.hasError('email')">{{ 'EMAIL_INVALID' | translate }}</ng-container>
        </div>

        <div style="color: rgb(92, 91, 91); font-size: 15px;">
          <br>
          on click you accept the <a href="https://www.totalum.app/terms-and-conditions" target="_blank">terms and conditions</a> and the <a href="https://www.totalum.app/politica-de-privacidad" target="_blank">privacy policy</a> of Totalum.
          </div>
        
          <div class="button">
            <ion-button mode="ios" class="button-margin-top" (click)="onSubmit()">
              <ion-label>{{ 'LOGIN' | translate }}</ion-label>
            </ion-button>
          </div>
          
      </ion-list>

        
      </form>
    </div>


  </div>



</ion-content>
